export const no = {
  whatsNew: {
    title: "Nyheter",
    intro: "Her er det nye i Vamos Tamos.",
    teamsTitle: "Lagre lagene dine",
    teamsBody: "Lagre en spillerliste med navn og firesifret PIN, og last den inn når som helst.",
    languagesTitle: "Flere språk",
    languagesBody: "Vamos Tamos snakker nå 6 språk, inkludert tysk og indonesisk.",
    cta: "Skjønner",
    badge: "Ny",
  },
  common: {
    loading: "Laster...",
    points: "poeng",
    court: "Bane",
    team: "Lag",
    player: "Spiller",
    rank: "Rang",
    score: "Poeng",
    share: "Del resultater",
    linkCopied: "Lenke kopiert til utklippstavlen",
    shareFailed: "Turneringen er for stor til å dele via URL. Prøv med færre spillere.",
    and: "og",
    close: "Lukk",
    save: "Lagre",
    cancel: "Avbryt",
    back: "Tilbake",
    yes: "Ja, Fjern",
    no: "Nei, Gå Tilbake",
    editable: "Redigerbar",
    buyMeCoffee: "Kjøp meg en kaffe",
  },
  results: {
    leastGames: "Færrest kamper",
    leastGamesTooltip: "Færrest spilte kamper",
  },
  tournament: {
    new: "Americano eller Mexicano?",
    create: "Opprett Turnering",
    nameRequired: "Turneringsnavn er påkrevd",
    tournamentName: "Turneringsnavn",
    round: "Runde",
    completeRound: "Fullfør Runde",
    completingRound: "Fullfører...",
    nextRoundReady: "Runde #{round} er klar",
    endTournament: "Avslutt Turnering",
    formatRequired: "Velg Americano eller Mexicano",
    enterScores: "Vennligst legg inn alle poeng før du fullfører runden",
    bench: "Spillere på benken",
    finalResults: "turnering",
    finished: "Turnering Fullført",
    winner: "Vinner",
    winners: "Vinnere",
    with: "med",
    points: "poeng",
    summary: "Turneringen ble fullført på {rounds} runder med {players} spillere på {courts} baner.",
    confirmEnd: "Er du sikker? Poeng fra denne runden blir ikke inkludert i totalscoren",
    yes: "Ja",
    no: "Nei",
    newTournament: 'Opprett ny turnering',
    playedMatches: 'Spilt',
    pairingComplete: "Paring Fullført",
    roundSaved: "Runde #{round} lagret",
    allPlayersPaired: "Turneringen ble fullført!",
    continueWithNewPairs: "Fortsett med Turnering",
    viewResults: "Se Resultater",
    tournamentEnded: "Turnering Avsluttet",
    roundSettings: "Rundeinnstillinger",
    pointsModeLabel: "Poengbasert til {points}",
    timeModeLabel: "Tidsbasert, {minutes} min",
    timer: "Timer: {time}",
    timerStatus: "Rundetimer",
    timeUp: "Tiden er ute! Avslutt runden og legg inn poeng.",
    editRoster: "Rediger Spillere",
    editRosterTitle: "Rediger Spillere og Baner",
    addPlayer: "Legg til Spiller",
    removePlayer: "Fjern",
    reactivatePlayer: "Reaktiver",
    inactivePlayers: "Inaktive Spillere",
    applyChanges: "Bruk Endringer",
    rosterWarning: "Gjeldende runde vil bli regenerert og poeng nullstilt",
    rosterWarningTitle: "Å bruke endringene starter denne runden på nytt",
    rosterWarningRegenerate: "Lagene for gjeldende runde blir stokket om og regenerert.",
    rosterWarningScores: "Poeng som allerede er lagt inn for denne runden, blir slettet.",
    rosterWarningNewPlayers: "Nye spillere blir med umiddelbart og legges til i denne runden.",
    rosterWarningSafe: "Poeng fra tidligere, fullførte runder beholdes.",
    minPlayersWarning: "Trenger minst 4 aktive spillere",
    courtsReduced: "Baner redusert til {courts} (ikke nok aktive spillere)",
    playerInactive: "Inaktiv",
    mixedPairsWarning: "Mikslag krever like mange menn og kvinner",
    arrangeFirstRound: "Sett opp første runde",
    arrangeFirstRoundTitle: "Sett opp første runde",
    arrangeFirstRoundHelp: "Trykk eller klikk på ett spillerkort og deretter på en annen plass for å bytte dem. Bruk benkeraden for å bytte spillere inn og ut. Dette fungerer likt på mobil og desktop.",
    resetFirstRound: "Tilbakestill endringer",
    firstRoundUpdated: "Første runde oppdatert",
    manualFirstRoundInvalid: "Hver aktive spiller må vises nøyaktig én gang i oppsettet for første runde.",
    manualFirstRoundMixedPairs: "Mikslag krever én mann og én kvinne på hvert lag.",
    manualFirstRoundBenchSlot: "Benkplass {number}",
    removePlayerTitle: "Fjern Spiller",
    removePlayerMessage: "Hvordan vil du fjerne {player}?",
    removePlayerExplanation: "Gjør Inaktiv: Spilleren forblir på resultatlisten, men blir ikke tildelt kamper. Fjern Helt: Spilleren slettes fra turneringen helt.",
    makeInactive: "Gjør Inaktiv (behold på resultatlisten)",
    removeCompletely: "Fjern Helt (slett fra turneringen)",
    removePlayerFinalTitle: "Er du sikker?",
    removePlayerFinalMessage: "Dette vil permanent slette {player} og alle deres poeng fra turneringen. Dette kan ikke angres."
  },
  tvMode: {
    subtitle: "Vis denne siden på en TV for å vise resultatliste og baner",
    round: "Runde {round}",
    leaderboard: "Resultatliste",
    lastRound: "Siste runde",
    onCourt: "På banen nå",
    noGames: "Ingen aktive kamper ennå",
    bench: "Venter denne runden",
    missingStateTitle: "TV-modus trenger en turneringslenke",
    missingStateBody: "Åpne TV-modus fra en aktiv eller ferdig turnering for å speile dataene på skjermen.",
    openButton: "Åpne TV-modus",
  },
  theme: {
    switchToDark: 'Bytt til mørk modus',
    switchToLight: 'Bytt til lys modus',
    toggleLabel: 'Veksle fargemodus',
  },
  playerSetup: {
    title: "Hvem spiller?",
    addPlayer: "Legg til spiller",
    playerName: "Spiller",
    playerRequired: "Spillernavn er påkrevd",
    formatTitle: "Turneringsstil",
    formatAmericano: "Americano-spill",
    formatMexicano: "Mexicano-spill",
    courtsTitle: "Antall baner",
    court: "Bane",
    courts: "Baner",
    startTournament: "Start Turnering",
    loadTeam: "Last inn lag",
    saveTeam: "Lagre lag",
    loadTeamTitle: "Last inn et lagret lag",
    saveTeamTitle: "Lagre dette laget",
    teamCode: "Lagnavn",
    loadTeamHint: "Skriv inn et lagnavn som er lett å huske for å gjenbruke spillerlisten.",
    saveTeamHint: "Gi denne spillerlisten et lett huskbart navn så du kan gjenbruke den neste gang.",
    savedTeamsTitle: "Dine lagrede lag",
    noSavedTeams: "Ingen lagrede lag på denne enheten ennå.",
    teamNameRequired: "Skriv inn et lagnavn",
    noPlayersToSave: "Legg til minst én spiller før du lagrer",
    teamNotFound: "Fant ingen lagret lag med det navnet",
    teamSaved: "Lag lagret",
    teamSaveFailed: "Kunne ikke lagre laget. Prøv igjen.",
    teamSavedLocally: "Laget er lagret på denne enheten. Deling er ikke bekreftet ennå.",
    teamLoaded: "Lag lastet inn",
    updatingTeam: "Lagring vil oppdatere laget ditt \"{name}\".",
    teamNameTaken: "Det navnet er allerede i bruk. Trykk på forslaget eller skriv et annet.",
    suggestionLabel: "Foreslått navn",
    load: "Last inn",
    createTeam: "Opprett lag",
    pinFourDigits: "PIN (4 sifre)",
    pinEnterPrompt: "Skriv inn lagets firesifrede PIN.",
    pinCreateWarning: "Du trenger denne PIN-koden for å laste inn laget senere. Den kan ikke gjenopprettes \u2014 hvis du glemmer den, må du opprette et nytt lag.",
    pinInvalid: "PIN må være 4 sifre.",
    pinIncorrect: "Feil PIN. PIN-koder kan ikke gjenopprettes \u2014 opprett et nytt lag hvis du har glemt den.",
    notEnoughPlayers: "Trenger minst {count} spillere for {courts} baner",
    duplicateName: "Duplikatnavn",
    roundTypeTitle: "Rundetype",
    roundTypePoints: "Poeng",
    roundTypeTime: "Tidsbasert",
    targetPoints: "Poeng å spille til",
    roundMinutes: "Minutter per runde",
    timerHint: "En fløyte og et banner vises når tiden er ute.",
    mixedPairsLabel: "Mikslag (M+K)",
    mexicanoPairingTitle: "Mexicano-paring",
    mexicanoPairingHint: "Velg hvordan hver bane med fire spillere deles inn i lag.",
    mexicanoPairingStandard: "Alternativ 1: #1 + #3 mot #2 + #4",
    mexicanoPairingStandardDescription: "Parer den høyest rangerte spilleren med nummer 3, og nummer 2 med nummer 4 på hver bane.",
    mexicanoPairingAlternate: "Alternativ 2: #1 + #4 mot #2 + #3",
    mexicanoPairingAlternateDescription: "Parer den beste spilleren med nummer 4, og de to i midten sammen på hver bane.",
    gender: "Kjønn",
    male: "Mann",
    female: "Kvinne",
    genderBalance: "Mikslag krever like mange mannlige og kvinnelige spillere."
  },
  rules: {
    titleAmericano: 'Hvordan Americano fungerer',
    titleMexicano: 'Hvordan Mexicano fungerer',
    teamSetupTitle: 'Lagoppsett',
    teamSetupAmericano: 'Spillere blir tilfeldig tildelt lag før hver runde for å sikre forskjellige lagkombinasjoner og motstandere.',
    teamPattern13v24: '#1+#3 spiller mot #2+#4',
    teamPattern14v23: '#1+#4 spiller mot #2+#3',
    teamSetupMexicano: 'Paringene følger den aktuelle resultatlisten. Spillerne grupperes i 4 etter rang (topp 4, neste 4, osv). På hver bane: {pattern}. Neste bane følger samme mønster. Dette gjør at sterke møter sterke og svakere møter svakere — målet er høy individuell poengsum, ikke ett vinnende par.',
    scoringSystemTitle: 'Poengsystem',
    scoringSystem: 'Hver runde spilles til et fast antall poeng eller på tid. Poeng tildeles individuelt – for eksempel, hvis et lag vinner 13–8, får hver spiller på vinnerlaget 13 poeng, og taperne får 8.',
    winnerTitle: 'Vinner',
    winner: 'Spilleren med flest poeng totalt vinner og får applaus fra de andre. :)',
    faqTitle: 'Ofte stilte spørsmål',
    faqFormatsQ: 'Hva er forskjellen på Americano og Mexicano?',
    faqFormatsA: 'I Americano settes spillerne sammen tilfeldig hver runde, slik at alle spiller med og mot alle. I Mexicano følger sammensetningen den direkte resultatlisten og matcher spillere på likt nivå.',
    faqSportsQ: 'Kan jeg bruke den til andre idretter enn padel?',
    faqSportsA: 'Ja. Selv om den er laget for padel, fungerer Americano- og Mexicano-formatene for pickleball, tennis, bordtennis, badminton og alle spill som telles i poeng.',
    faqFreeQ: 'Er den gratis, og trenger jeg konto?',
    faqFreeA: 'Den er helt gratis uten registrering. Turneringene kjører i nettleseren og fungerer offline.',
    faqPlayersQ: 'Hvor mange spillere og baner kan jeg bruke?',
    faqPlayersA: 'Et hvilket som helst antall spillere på én eller flere baner. Appen roterer spillerne automatisk hver runde.'
  },
  privacy: {
    title: 'Personvernerklæring',
    lastUpdated: 'Sist oppdatert',
    dataCollection: 'Datainnsamling',
    dataCollectionText: 'Vamos Tamos samler ikke inn eller lagrer persondata. All turneringsdata forblir på enheten din.',
    localStorage: 'Lokal Lagring',
    localStorageText: 'Turneringsdata lagres lokalt i nettleserens localStorage for å opprettholde spillstatus. Du kan slette disse dataene når som helst via nettleserinnstillingene.',
    cookies: 'Informasjonskapsler',
    cookiesText: 'Denne appen bruker ikke sporings-informasjonskapsler. Kun essensiell nettleserlagring (localStorage) brukes for turneringsfunksjonalitet.',
    thirdParty: 'Tredjepartstjenester',
    thirdPartyText: 'Vi bruker Vercel Web Analytics for å samle inn anonyme, aggregerte bruksdata (sidevisninger, besøkstall). Disse dataene er personvernfokuserte og sporer ikke individuelle brukere, bruker ikke informasjonskapsler, eller samler inn personlig informasjon. Les mer på vercel.com/analytics.',
    rights: 'Dine Rettigheter (GDPR/CCPA)',
    rightsText: 'Siden ingen persondata samles inn eller behandles, beholder du full kontroll over dataene dine. Du kan slette all lokalt lagret turneringsdata ved å tømme nettleserens localStorage.',
    contact: 'Kontakt',
    contactText: 'For personvernspørsmål, kontakt: the.adnan@gmail.com',
    backHome: 'Tilbake til Hjem'
  }
};
